
import React from "react";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
} from "reactstrap";

export default function SeniorKycConsentModal({
	isOpen,
	onClose,      // () => void
	onConsent,    // () => void
}) {
	return (
		<Modal isOpen={isOpen} centered size="md">
			<ModalHeader>Learner Support Verification</ModalHeader>
			<ModalBody>
				<div
					style={{
						textAlign: "left",
						fontSize: "0.95rem",
						lineHeight: "1.5rem",
					}}
				>
					<p>
						Dear Learner, to ensure every participant has a smooth and rewarding learning experience, we conduct an additional verification step as part of our enrolment process.
					</p>
					<p>
						Before you proceed, one of our managers will give you a call to go through the course prerequisites and key requirements in detail, and to address any questions you may have.
					</p>
					<p>
						By continuing, you consent to us contacting you for this purpose.
					</p>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={onClose}>
					Cancel
				</Button>
				<Button color="primary" onClick={onConsent}>
					I Understand and Continue
				</Button>
			</ModalFooter>
		</Modal>
	);
}
